export const GUESSES_LIMIT = 6;
